import React from "react";
import { Link } from "react-router-dom";
import ExercisePanel from "../exercise_panel/ExercisePanel";
import { useParams } from "react-router-dom";

const ExercisesList = ({subTitle, sectionName, exercisesList}) => {

    let params = useParams();
    var title = params.title;
    var subTitle = params.subTitle;
    // var sectionName = params.section;

    const containerName = `${sectionName}-exercises-list-container`;
    const exercisesListClassName = `${subTitle}-exercises-list`;
    var formattedLink = `/advanced/${title}/${subTitle}/${sectionName}/`;

    const writeSectionNameAsTitle = (sectionName) => {
        let sectionNameAsTitle = sectionName.replaceAll('_', ' ');
        sectionNameAsTitle = sectionNameAsTitle.toUpperCase();
        return sectionNameAsTitle;
    };
    
    return (
        <div className={containerName}>
                <h5>{writeSectionNameAsTitle(sectionName)}</h5>
                <div className={exercisesListClassName}>
                    {exercisesList.map((exerciseObj, index) => (
                        // <ExercisePanel exercise_path={exerciseObj.path} exercise_id={exerciseObj.id} exercise={exerciseObj.exercise}/>
                        <div key={index}>
                            <Link to={formattedLink + exerciseObj.id} style={{ textDecoration: 'none' }}>
                                <ExercisePanel sectionName={sectionName} exercise_id={exerciseObj.id} exercise_content={exerciseObj.exercise} exercise_difficulty={exerciseObj.difficulty}/>
                            </Link>
                        </div>
                    ))}
                </div>
        </div>
    );
}

export default ExercisesList;
